import { Entity, IEntity } from "./Entity";
import { IApp03Task } from "./App03Task";
import { IUser } from "./User";

export interface IApp03SubTask extends IEntity {
    App03TaskID?: number;
    Details?: string;
    Stage?: string;
    AssignedToUserID?: number;
    AddedByID?: number;
    AddedOn?: Date;
    UpdatedByID?: number;
    UpdatedOn?: Date
    App03Task?: IApp03Task;
    AssignedToUser?: IUser;
}

export class App03SubTask extends Entity implements IApp03SubTask {
    public App03TaskID = null;
    public Details = null;
    public Stage = null;
    public AssignedToUserID = null;
    //public AddedByID = null;
    //public AddedOn = null;
    //public UpdatedByID = null;
    //public UpdatedOn = null;

    constructor(app03TaskID: number) {
        super();
        this.App03TaskID = app03TaskID;
        this.Stage = 'Not Started'; //default value
    }
}